import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=7a8e623c"
import script from "./Arrivals.vue?vue&type=script&lang=js"
export * from "./Arrivals.vue?vue&type=script&lang=js"
import style0 from "./Arrivals.vue?vue&type=style&index=0&id=7a8e623c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports